import { getTranslation } from "@/i18n/get-translation";
import Link from "next/link";

interface INewsPagination {
  locale: string;
}

export default function NewsPagination({ locale }: INewsPagination) {
  const t = getTranslation(locale, "newsPagination");
  return (
    <div
      className="flex md:items-center justify-start gap-[0.8rem] font-light md:text-lg text-base items-start lg:pt-8 pt-6 px-20 max-md:px-7 relative"
      aria-label="Global"
    >
      <Link href="/" className="text-primary-700 ">
        {t("home")}
      </Link>
      <span>/</span>
      <Link href={`/${locale}/news`} className="text-primary-700">
        {t("news")}
      </Link>
    </div>
  );
}
